import { makeStyles, shorthands } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useAdminListPageStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    minWidth: 0,
    fontFamily: designTokens.fontFamily,
    backgroundColor: "transparent",
  },

  header: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[3],
    flexWrap: "wrap",
    padding: `${designTokens.spacing[5]} ${designTokens.spacing[6]}`,
    [`@media (max-width: 640px)`]: {
      padding: `${designTokens.spacing[3]} ${designTokens.spacing[4]}`,
    },
  },

  subHeader: {
    padding: `0 ${designTokens.spacing[6]} ${designTokens.spacing[3]}`,
    [`@media (max-width: 640px)`]: {
      padding: `0 ${designTokens.spacing[4]} ${designTokens.spacing[3]}`,
    },
  },

  subHeaderNoPadding: {
    paddingLeft: "0",
    paddingRight: "0",
  },

  searchBoxContainer: {
    flex: 1,
    minWidth: "200px",
    maxWidth: "320px",
    [`@media (max-width: 640px)`]: {
      maxWidth: "none",
      minWidth: 0,
      width: "100%",
    },
  },

  filterContainer: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[3],
  },

  headerActions: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
    marginLeft: "auto",
  },

  body: {
    flex: 1,
    minWidth: 0,
    minHeight: 0,
    overflowY: "auto" as const,
    padding: `${designTokens.spacing[4]} ${designTokens.spacing[6]} ${designTokens.spacing[5]}`,
    [`@media (max-width: 640px)`]: {
      padding: `${designTokens.spacing[3]} ${designTokens.spacing[3]} ${designTokens.spacing[3]}`,
    },
  },

  headerNoPadding: {
    paddingLeft: "0",
    paddingRight: "0",
  },

  bodyNoPadding: {
    paddingLeft: "0",
    paddingRight: "0",
  },

  tableContainer: {
    backgroundColor: designTokens.neutral.white,
    borderRadius: designTokens.borderRadius.lg,
    ...shorthands.border("1px", "solid", designTokens.neutral[200]),
    boxShadow: designTokens.shadow.sm,
    overflow: "hidden",
  },
});
